import moment from 'moment';
import { defaultAgent, apiResponse } from '../helpers/web-agent';
import { tokenExpired } from './auth';
import { toastError } from './toast';
import { subscribe, unsubscribe } from "./socket";
import { dateToUTC } from '../helpers/moment-ex';
import { getEGSpeed, parseBaleKPI } from '../interceptors/analyze';
import {
    isEGView, isCrewView, isFarmView, isElasticLoad,
    isToday, isPlannedOrTodate, isCustom,
    isCustomerView
} from '../helpers/common';
import { NO_RECORD_FOUND, RECORD_FOUND } from '../constants/messages';
import {
    TOPIC_KPI_EG, TOPIC_KPI_CREW, TOPIC_KPI_PLAN,
    TOPIC_LOAD_CREW, TOPIC_LOAD_EG, TOPIC_LOAD_PLAN,
    TOPIC_LATEST_KPI_PLAN, TOPIC_LATEST_KPI_CREW, TOPIC_LATEST_KPI_EG, GROUP_ANALYZE_KPI, API_DATETIME_FORMAT, VIEW_EG
} from '../constants';
import {
    GET_PLANNED_TODATE_REQUEST, GET_PLANNED_TODATE,
    GET_SUMMARY_REQUEST, GET_SUMMARY, GET_DONUT_REQUEST, GET_DONUT,
    GET_GRAPH_REQUEST, GET_GRAPH, GET_TRUCK_LOAD_REQUEST, GET_TRUCK_LOAD,
    GET_BALE_KPI_REQUEST, GET_BALE_KPI, GET_WORKED_KPI_REQUEST, GET_WORKED_KPI,
    GET_SPEED_REQUEST, GET_SPEED, ANALYZE_PARAMS, SET_SEARCH_PARAMS,
    PLAN_ANALYZE_INFO, EG_ANALYZE_INFO, CREW_ANALYZE_INFO,
    OPERATOR_ANALYZE_INFO, CLEAR_ANALYZE_DATA, SET_RETAIN_DATE_TOGGLE, TRAVEL_KPI, TRAVEL_KPI_REQUEST, ANALYZE_RECENT_SUMMARY, SET_LOAD_INFO, SET_LOAD_INFO_REQUEST,
    CUSTOMER_ANALYZE_INFO
} from '../constants/action-types';
import { egSpeedData, egSpeedDataRequest } from './dashboard';

export const plannedTodateRequest = (rangeType, id) => ({ type: GET_PLANNED_TODATE_REQUEST, rangeType, id });

export const plannedTodate = (rangeType, id, data) => ({ type: GET_PLANNED_TODATE, rangeType, id, payload: data });

export const summaryRequest = () => ({ type: GET_SUMMARY_REQUEST });

export const summaryInfo = payload => ({ type: GET_SUMMARY, payload });

export const donutRequest = () => ({ type: GET_DONUT_REQUEST });

export const donutInfo = payload => ({ type: GET_DONUT, payload });

export const graphRequest = () => ({ type: GET_GRAPH_REQUEST });

export const graphInfo = payload => ({ type: GET_GRAPH, payload });

export const truckLoadRequest = () => ({ type: GET_TRUCK_LOAD_REQUEST });

export const truckLoad = payload => ({ type: GET_TRUCK_LOAD, payload });

export const baleKPIRequest = () => ({ type: GET_BALE_KPI_REQUEST });

export const baleKPI = payload => ({ type: GET_BALE_KPI, payload });

export const workedKPIRequest = () => ({ type: GET_WORKED_KPI_REQUEST });

export const workedKPI = payload => ({ type: GET_WORKED_KPI, payload });

export const analyzeParams = payload => ({ type: ANALYZE_PARAMS, payload });

export const speedDataRequest = () => ({ type: GET_SPEED_REQUEST });

export const speedData = payload => ({ type: GET_SPEED, payload });

export const planAnalyzeInfo = (farmId, planTypeId) =>
    ({ type: PLAN_ANALYZE_INFO, payload: { farmId, planTypeId } });

export const crewAnalyzeInfo = (crewId, title) =>
    ({ type: CREW_ANALYZE_INFO, payload: { crewId, title } });

export const customerAnalyzeInfo = (customerId, title) =>
    ({ type: CUSTOMER_ANALYZE_INFO, payload: { customerId, title } });

export const egAnalyzeInfo = (crewId, crews, egId, title, isTruck, categeryId) =>
    ({ type: EG_ANALYZE_INFO, payload: { crewId, crews, egId, title, isTruck, categeryId } });

export const operatorAnalyzeInfo = (operatorId, title) =>
    ({ type: OPERATOR_ANALYZE_INFO, operatorId, title });

export const setSearchParams = data => ({ type: SET_SEARCH_PARAMS, payload: data });

export const clearAnalyzeData = () => ({ type: CLEAR_ANALYZE_DATA });

export const isToggleRetainDate = () => ({ type: SET_RETAIN_DATE_TOGGLE });

export const travelKpiRequest = () => ({ type: TRAVEL_KPI_REQUEST });

export const travelKpi = payload => ({ type: TRAVEL_KPI, payload });

export const analyzeRecentSummary = payload => ({ type: ANALYZE_RECENT_SUMMARY, payload });

export const setLoadInfoRequest = () => ({ type: SET_LOAD_INFO_REQUEST });

export const setLoadInfo = ({ payload, loadType }) => ({ type: SET_LOAD_INFO, payload, loadType });

export const reportSearchParams = data => dispatch => {
    defaultAgent.put(`api/user/settings/update`, { report_date_range: data })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(tokenExpired());
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Reported Date: ', ex.message);
        });
}

export const getPlannedTodate = (params, cb = null) => (dispatch) => {
    let id = null;
    let reqParams = {};
    let reqUrl = null;

    if (params.crewId) {
        id = params.crewId;
        reqUrl = "/crew";
        reqParams = { farm_uuid: params.farmId, crew_uuid: params.crewId, range_type: params.range };
    } else if (params.farmId) {
        id = params.planTypeId ? `${params.farmId}_${params.planTypeId}` : params.farmId;
        reqUrl = "/plan";
        reqParams = { farm_uuid: params.farmId, range_type: params.range, plan_type_id: params.planTypeId }
    }

    if (!(params.range && id && isPlannedOrTodate(params.range))) {
        if (cb) return cb(false, null);
        else return;
    };

    const requestId = `planned_todate_${id}`;
    dispatch(plannedTodateRequest(params.range, id));

    defaultAgent.get(`api${reqUrl}/plannedDate`, reqParams, { requestId: `analyze_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(plannedTodate(params.range, id));
                if (cb) cb(false, null);
            } else if (agentResult.data) {
                dispatch(plannedTodate(params.range, id, agentResult.data));
                if (cb) cb(true, agentResult.data);
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Planned todate info: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(plannedTodate(params.range, id));
            if (cb) cb(false, null);
        });
};

export const getSpeed = params => (dispatch, getState) => {
    const requestFrom = (params && params.requestFrom) ? params.requestFrom : null;
    if (isPlannedOrTodate(params.range)) {
        if (requestFrom && params.requestFrom === 'dashboard') {
            return dispatch(egSpeedData({ egId: params.egId, data: {}, isRequesting: false }));
        } else {
            return dispatch(speedData());
        }
    }

    const startDate = moment.utc(params.fromDate);
    const endDate = moment.utc(params.toDate);
    if (isCustom(params.range) && endDate.diff(startDate, "hours") > 24) return dispatch(speedData());

    const sliceHours = 4;
    const timezone = getState().farm.currentFarm.timezone_identifier;
    const startUTCTime = dateToUTC(startDate, timezone).clone();
    const endUTCTime = dateToUTC(endDate, timezone).clone();
    const diffMinutes = endUTCTime.diff(startUTCTime, "minutes");
    const reqCount = Math.ceil(diffMinutes / (sliceHours * 60));
    const promises = [];

    const sensorRequest = reqParams => {
        return defaultAgent.post('/api/equipment/group/sensor/data', reqParams)
            .then(res => {
                const agentResult = apiResponse(res, []);
                if (agentResult.code === RECORD_FOUND.code) return agentResult.data;
                else if (agentResult.message) console.log(agentResult.message);
                return [];
            });
    };

    for (let i = 0; i < reqCount; i++) {
        const start = (i > 0) ? startUTCTime.clone().add(i * sliceHours, 'hours') : startUTCTime.clone();
        const end = (i < (reqCount - 1)) ? start.clone().add(sliceHours, 'hours') : endUTCTime.clone();

        const reqParams = {
            equipment_group_uuid: params.egId,
            sensor: 'gps',
            start_date: start.format(),
            end_date: end.format()
        }
        promises.push(sensorRequest(reqParams));
    }

    if (requestFrom && params.requestFrom === 'dashboard') {
        dispatch(egSpeedDataRequest({ egId: params.egId, data: {}, isRequesting: true }))
    } else {
        dispatch(speedDataRequest());
    }

    Promise.all(promises).then((values) => {
        if (requestFrom && params.requestFrom === 'dashboard') {
            const data = getEGSpeed(values);
            dispatch(egSpeedData({ egId: params.egId, data: data, isRequesting: false }));
        } else {
            dispatch(speedData(getEGSpeed(values)))
        }
    });
}

export const getDonut = data => dispatch => {
    dispatch(donutRequest());

    const req = getRequestParams(data);
    if (!req.apiName) return dispatch(donutInfo());

    defaultAgent.get(`/api${req.apiName}/v1/donut`, req.params, { requestId: "analyseDonut" })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(donutInfo());
            } else if (agentResult.data) {
                dispatch(donutInfo(agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Analyse Donut: ', ex.message);
            dispatch(toastError(ex.message));
            dispatch(donutInfo());
        });
}

export const getGraph = data => dispatch => {
    dispatch(graphRequest());

    const req = getRequestParams(data);
    if (!req.apiName) return dispatch(graphInfo());

    defaultAgent.get(`/api${req.apiName}/v1/chart`, req.params, { requestId: "analyseGraph" })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(graphInfo());
            } else if (agentResult.data) {
                dispatch(graphInfo(agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Analyse Graph: ', ex.message);
            dispatch(toastError(ex.message));
            dispatch(graphInfo());
        });
}

export const getSummary = (data, cb) => dispatch => {
    dispatch(summaryRequest());

    const req = getRequestParams(data);
    const done = response => {
        dispatch(summaryInfo(response));
        if (!isCustomerView(data.view)) {
            dispatch(callKPI(data, response));
        }
        return cb ? cb() : null;
    };

    if (!req.apiName) return done();
    defaultAgent.get(`/api${req.apiName}/v1/summary`, req.params, { requestId: "analyseSummary" })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                done();
            } else if (agentResult.data) {
                done(agentResult.data);
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Analyse Summary: ', ex.message);
            dispatch(toastError(ex.message));
            return done();
        });
}

export const callKPI = (params, payload) => dispatch => {
    const dateInfo = getDateRangeWith(params, payload);
    const paramsWith = { ...params, ...dateInfo, withDate: true };
    dispatch(getWorkedKPI(paramsWith));

    //const isLoad = isEGView(params.view) ? params.isHarvester : true;
    const isLoad = !isEGView(params.view);
    if (params.isElasticLoad && isLoad) dispatch(getAutomaticLoad(paramsWith));
    return;
};

export const getWorkedKPI = params => dispatch => {
    let apiName = null, deviceId = null;

    const reqParams = {
        farm_uuid: params.farmId,
        start_date: params.fromDate,
        end_date: params.toDate
    };

    if (isEGView(params.view)) {
        apiName = 'equipment/group';
        reqParams.equipment_group_uuid = params.egId;
        deviceId = params.egId;
        reqParams.include_work = true;
    }
    else if (isCrewView(params.view)) {
        apiName = 'crew';
        reqParams.crew_uuid = params.crewId;
        deviceId = params.crewId;
    }
    else if (isFarmView(params.view)) {
        apiName = 'farm';
        deviceId = params.farmId;
    } else if (isCustomerView(params.view)) {
        apiName = 'customer';
        deviceId = params.customerId;
    }

    dispatch(workedKPIRequest());
    defaultAgent.post(`api/${apiName}/kpi/data`, reqParams, { requestId: "analyseKPIData" })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message)
                dispatch(toastError(agentResult.message));
            else if (agentResult.data) {
                const elastic = { work: { data: agentResult.data, deviceId, range: params.range, isLive: false } };
                dispatch(workedKPI(elastic));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Analyse KPI Data: ', ex.message);
            dispatch(toastError(ex.message));
        });
}

export const getTruckLoad = params => dispatch => {
    if (isElasticLoad()) {
        dispatch(truckLoad());
        dispatch(getAutomaticLoad(params));
    } else {
        dispatch(getManualTruckLoad(params));
    }
};

export const getManualTruckLoad = (data, cb) => dispatch => {
    dispatch(truckLoadRequest());

    const reqParams = {
        farm_uuid: data.farmId,
        crew_uuid: data.crewId,
        equipment_group_uuid: data.egId,
        range_type: data.range,
        from_date: data.fromDate,
        to_date: data.toDate,
        ...data.planTypeId && {
            plan_type_id: data.planTypeId
        },
        is_tareload: data.is_tareload
    };

    const api = data && data.planTypeId && data.planTypeId === 2 ? '/api/seed/load' : '/api/equipment/group/load/v1'

    defaultAgent.get(api, reqParams, { requestId: "analyseManualLoad" })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(truckLoad());
            } else if (agentResult.data) {
                dispatch(truckLoad(agentResult.data));
                if (cb) cb(agentResult.data);
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Analyse Manual Load: ', ex.message);
            dispatch(toastError(ex.message));
            dispatch(truckLoad());
        });
};

export const getAutomaticLoad = params => dispatch => {
    const reqParams = { farm_uuid: params.farmId };
    let deviceId = null, apiName = null;

    if (isFarmView(params.view)) {
        apiName = 'farm';
        deviceId = params.farmId;
    }
    else if (isCrewView(params.view)) {
        apiName = 'crew';
        deviceId = params.crewId;
        reqParams.crew_uuid = params.crewId;
    }
    else if (isEGView(params.view)) {
        apiName = 'equipment/group';
        deviceId = params.egId;
        reqParams.equipment_group_uuid = params.egId;
    }

    if (isEGView(params.view) && params.isTruck) dispatch(workedKPIRequest());

    const getLoadEstimate = date => {
        reqParams.start_date = moment.utc(date ? date.fromDate : params.fromDate).format();
        reqParams.end_date = moment.utc(date ? date.toDate : params.toDate).format();

        defaultAgent.get(`api/${apiName}/load/estimate/summary`, reqParams, { requestId: "analyseAutomaticLoad" })
            .then(res => {
                const agentResult = apiResponse(res, []);
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.message)
                    dispatch(toastError(agentResult.message));
                else if (agentResult.data) {
                    const elastic = { load: { data: agentResult.data, deviceId, range: params.range, isLive: false } };
                    dispatch(workedKPI(elastic));
                }
            }).catch(ex => {
                if (defaultAgent.isCancel(ex)) return console.log('Analyse Automatic Load: ', ex.message);
                dispatch(toastError(ex.message));
            });
    };

    if (!params.withDate && isPlannedOrTodate(params.range)) {
        // Get planned date
        dispatch(getPlannedDate(params, payload => {
            if (payload && payload.start_date && payload.end_date) {
                return getLoadEstimate({
                    fromDate: payload.start_date,
                    toDate: payload.end_date
                });
            }
            else {
                const elastic = { load: { data: null, deviceId, range: params.range, isLive: false } };
                dispatch(workedKPI(elastic));
            }
        }));
    } else return getLoadEstimate();
};

export const getPlannedDate = (params, cb = null) => dispatch => {
    const req = getRequestParams(params);
    if (!req.apiName) return cb && cb();

    // instead of planned date api for temporally
    defaultAgent.get(`/api${req.apiName}/load/v1`, req.params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        }
        if (cb) return cb(agentResult.data);
    }).catch(ex => {
        dispatch(toastError(ex.message));
        if (cb) cb();
    });
};

export const getBaleKPI = params => (dispatch, getState) => {
    const getBaleSensor = ({ fromDate, toDate }) => {
        const timezone = getState().farm.currentFarm.timezone_identifier;
        fromDate = dateToUTC(fromDate, timezone).format();
        toDate = dateToUTC(toDate, timezone).format();

        defaultAgent.post(`/api/equipment/group/sensor/data`, {
            equipment_group_uuid: params.egId,
            sensor: "bale",
            start_date: fromDate,
            end_date: toDate
        }, { requestId: `AnalyseBaleSensor` }).then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(baleKPI());
            } else if (agentResult.data) {
                dispatch(baleKPI(parseBaleKPI(agentResult.data, params.egId)));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Anlayze bale sensor: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(baleKPI());
        });
    }

    dispatch(baleKPIRequest());
    if (!isPlannedOrTodate(params.range)) return getBaleSensor(params);
    if (!params.crewId) return dispatch(baleKPI());

    defaultAgent.get(`api/crew/plannedDate`, {
        farm_uuid: params.farmId,
        crew_uuid: params.crewId,
        range_type: params.range
    }, { requestId: `AnalyseBalerPlannedDate` }).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            dispatch(baleKPI());
        } else if (agentResult.data) {
            const date = agentResult.data;
            if (date.start_date && date.end_date)
                getBaleSensor({ fromDate: date.start_date, toDate: date.end_date });
            else dispatch(baleKPI());
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log(`Planned date for anlayze bale: `, ex.message);
        dispatch(toastError(ex.message));
        dispatch(baleKPI());
    });
}

export const subscribeAnalyzeKPI = params => dispatch => {
    if (!window.socketClient) return;
    const { range } = params;
    const actionList = window.socketClient.getActionList();

    if (isToday(range)) {
        const isSubscribed = deviceId => {
            if (actionList.hasOwnProperty(GROUP_ANALYZE_KPI)) {
                const findActions = actionList[GROUP_ANALYZE_KPI].filter(e => e.deviceId === deviceId);
                return (findActions.length > 0);
            }
            return false;
        };

        const topics = getAnalyzeTopics(params);
        const notifications = [];
        for (const item of topics) {
            if (item.subscribeDeviceId && isSubscribed(item.subscribeDeviceId)) continue;
            notifications.push({
                deviceId: item.subscribeDeviceId, name: item.topic,
                ...item.action && { action: item.action },
                ...item.parameters && { parameters: item.parameters }
            });
        }

        if (notifications.length > 0) dispatch(subscribe(notifications, GROUP_ANALYZE_KPI, true));
    } else if (actionList.hasOwnProperty(GROUP_ANALYZE_KPI)) {
        dispatch(unsubscribeAnalyzeKPI(true));
    }
    return;
}

export const unsubscribeAnalyzeKPI = clearMessages => dispatch => {
    return dispatch(unsubscribe(GROUP_ANALYZE_KPI, clearMessages));
}

export const getAnalyzeTopics = params => {
    const topics = [], isAutomatic = isElasticLoad();
    if (isEGView(params.view)) {
        topics.push({ deviceId: params.egId, subscribeDeviceId: params.egId, action: TOPIC_LATEST_KPI_EG, keyname: "work", parameters: { include_work: true } });
        topics.push({ deviceId: params.egId, subscribeDeviceId: params.egId, topic: TOPIC_KPI_EG, keyname: "work" });
        if (isAutomatic) topics.push({ deviceId: params.egId, subscribeDeviceId: params.crewId, topic: TOPIC_LOAD_EG, keyname: "load" });
    }
    else if (isCrewView(params.view)) {
        topics.push({ deviceId: params.crewId, subscribeDeviceId: params.crewId, action: TOPIC_LATEST_KPI_CREW, keyname: "work", parameters: { include_work: true } });
        topics.push({ deviceId: params.crewId, subscribeDeviceId: params.crewId, topic: TOPIC_KPI_CREW, keyname: "work" });
        if (isAutomatic) topics.push({ deviceId: params.crewId, subscribeDeviceId: params.crewId, topic: TOPIC_LOAD_CREW, keyname: "load" });
    }
    else if (isFarmView(params.view)) {
        topics.push({ deviceId: params.farmId, subscribeDeviceId: params.farmId, action: TOPIC_LATEST_KPI_PLAN, keyname: "work", parameters: { include_work: true } });
        topics.push({ deviceId: params.farmId, subscribeDeviceId: params.farmId, topic: TOPIC_KPI_PLAN, keyname: "work" });
        if (isAutomatic) topics.push({ deviceId: params.farmId, subscribeDeviceId: params.farmId, topic: TOPIC_LOAD_PLAN, keyname: "load" });
    }

    return topics;
}

export const getRequestParams = data => {
    let apiName = null;
    const params = {
        farm_uuid: data.farmId,
        range_type: data.range,
        from_date: data.fromDate,
        to_date: data.toDate
    };

    if (isFarmView(data.view)) {
        apiName = "/plan";
        params.region_uuid = data.regionId;
        if (data.hasOwnProperty("planTypeId")) params['plan_type_id'] = data.planTypeId;
    } else if (isCrewView(data.view)) {
        apiName = "/crew";
        params.crew_uuid = data.crewId;
        if (data.hasOwnProperty("planTypeId")) params['plan_type_id'] = data.planTypeId;
    } else if (isCustomerView(data.view)) {
        apiName = "/customer";
        params.customer_uuid = data.customerId;
        if (data.hasOwnProperty("planTypeId")) params['plan_type_id'] = data.planTypeId;
    } else if (isEGView(data.view)) {
        apiName = "/equipment/group";
        params.crew_uuid = data.crewId;
        params.equipment_group_uuid = data.egId;
        if (data.hasOwnProperty("planTypeId")) params['plan_type_id'] = data.planTypeId;
    }
    params.include_events = true;

    if (data.hasOwnProperty("planTypeId") && data.planTypeId === 10) params['plan_type_id'] = 4;
    return { apiName, params };
}

export const getDateRangeWith = (params, payload) => {
    const date = { fromDate: null, toDate: null };

    if (isPlannedOrTodate(params.range)) {
        if (payload && payload.start_date && payload.end_date) {
            date.fromDate = moment.utc(payload.start_date).startOf('day').format();
            date.toDate = moment.utc(payload.end_date).endOf('day').format();
        }
    }
    else if (params.fromDate && params.toDate) {
        date.fromDate = moment.utc(params.fromDate).format();
        date.toDate = moment.utc(params.toDate).format();
    }

    return date;
}

export const getDateRangeInfo = (params, cb) => (dispatch, getState) => {
    const state = getState();
    const range = state.analyze.searchParams.range;
    const dateInfo = { range, fromDate: null, toDate: null };

    const done = () => cb ? cb(dateInfo) : dateInfo;

    if (isPlannedOrTodate(range) && params) {
        let requestId = null;

        if (params.crewId) requestId = params.crewId;
        else if (params.farmId) {
            if (params.planTypeId) requestId = `${params.farmId}_${params.planTypeId}`;
            else {
                // requestId = `${params.farmId}`;
                dateInfo.fromDate = moment.utc().startOf("year").format(API_DATETIME_FORMAT);
                dateInfo.toDate = moment.utc().format(API_DATETIME_FORMAT);
                return done();
            }
        }

        if (!requestId) return done();

        const plannedTodateList = state.analyze.searchParams.plannedTodate;

        const planPlannedToDateRequesting = plannedTodateList[requestId]
            ? plannedTodateList[requestId].isRequesting : false;
        const planPlannedToDate = plannedTodateList[requestId] && plannedTodateList[requestId][range]
            ? plannedTodateList[requestId][range] : null;

        if (planPlannedToDateRequesting) return;
        dateInfo.fromDate = planPlannedToDate ? planPlannedToDate.from : null;
        dateInfo.toDate = planPlannedToDate ? planPlannedToDate.to : null;

        if (!planPlannedToDate) {
            const reqParams = { ...params, range }
            dispatch(getPlannedTodate(reqParams, (isSuccess, payload) => {
                if (!isSuccess || !payload) return done(dateInfo);
                if (payload.start_date && payload.end_date) {
                    dateInfo.fromDate = moment.utc(payload.start_date).format(API_DATETIME_FORMAT);
                    dateInfo.toDate = moment.utc(payload.end_date).format(API_DATETIME_FORMAT);
                }
                return done();
            }))
        } else return done();
    } else {
        if (!isPlannedOrTodate(range)) {
            const custom = state.analyze.searchParams.custom;
            dateInfo.fromDate = custom ? custom.from : null;
            dateInfo.toDate = custom ? custom.to : null;
        }
        return done();
    }
};

export const fetchSensorData = (data, cb) => dispatch => {
    dispatch(travelKpiRequest());
    defaultAgent.post('/api/equipment/group/kpi/travel', data).then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.code === RECORD_FOUND.code) {
            dispatch(travelKpi(agentResult.data));
        } else if (agentResult.code === NO_RECORD_FOUND.code) {
            dispatch(travelKpi(agentResult.data));
        } else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            if (cb) cb(false);
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        if (cb) cb(false);
    });
}

export const getTotalLoadInfo = data => dispatch => {
    const req = getRequestParams(data);
    if (!req.apiName) return dispatch(setLoadInfo({ payload: null, loadType: 'load' }));

    let reqParams = { ...req.params, __t: new Date().getTime() };
    if (data.view === VIEW_EG) {
        delete reqParams.equipment_group_uuid;
        reqParams = data.isTruck ?
            { ...reqParams, target_equipment_group_uuid: data.egId } :
            { ...reqParams, source_equipment_group_uuid: data.egId };
    }

    //reqParams['filter'] = 'last';    

    dispatch(setLoadInfoRequest());
    defaultAgent.get(`/api${req.apiName}/load/v1/history`, reqParams, { requestId: "loadHistoryForCSV" }).then(res => {
        const agentResult = apiResponse(res);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            dispatch(setLoadInfo({ payload: null, loadType: 'load' }));
        } else if (agentResult.data) {
            dispatch(setLoadInfo({ payload: agentResult.data, loadType: 'load' }));
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log('Load History CSV: ', ex.message);
        dispatch(toastError(ex.message));
        dispatch(setLoadInfo({ payload: null, loadType: 'load' }));
    });
}

export const getTotalTareInfo = data => dispatch => {
    const req = getRequestParams(data);
    if (!req.apiName) return dispatch(setLoadInfo({ payload: null, loadType: 'tare' }));

    let reqParams = { ...req.params, __t: new Date().getTime() };
    if (data.view === VIEW_EG) {
        delete reqParams.equipment_group_uuid;
        reqParams = data.isTruck ?
            { ...reqParams, target_equipment_group_uuid: data.egId } :
            { ...reqParams, source_equipment_group_uuid: data.egId };
    }

    reqParams['filter'] = 'last';
    reqParams['is_tareload'] = true;

    // dispatch(loadHistoryRequest());
    defaultAgent.get(`/api${req.apiName}/load/v1/history?t=123`, reqParams, { requestId: "loadHistoryForCSV" }).then(res => {
        const agentResult = apiResponse(res);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            dispatch(setLoadInfo({ payload: null, loadType: 'tare' }));
        } else if (agentResult.data) {
            dispatch(setLoadInfo({ payload: agentResult.data, loadType: 'tare' }));
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log('Load History CSV: ', ex.message);
        dispatch(toastError(ex.message));
        dispatch(setLoadInfo({ payload: null, loadType: 'tare' }));
    });
}